<template>
  <!-- 审批按钮 -->
  <div >
    <!--拒绝的弹窗-->
    <a-modal
      title="审核驳回"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="modalForm">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="驳回原因">
          <a-textarea v-decorator="['checkRemark', decoratorOptions.checkRemark]" placeholder="请输入至少5个字符"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <div class="bottom_banner">
       <a-button @click="visible = true" style='margin-right:20px;'>驳回</a-button>
        <a-button type="primary" @click="pass" style='margin-right:20px;'>通过</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'approvalModel',
  props: ['id', 'isStore'],
  data () {
    return {
      visible: false,
      btnLoading: { loading: false },
      decoratorOptions: {
        checkRemark: {
          rules: [
            { required: true, message: '请输入驳回原因' },
            { min: 5, message: '驳回原因最少5个字' },
            {pattern: /^([\s]*[\S]+[\s]*[\S]*)+$/, message: '不能为空'}
          ]
        }
      }

    };
  },
  beforeCreate () {
    this.modalForm = this.$form.createForm(this);
  },
  created () {
  },
  methods: {
    show () {
      this.visible = true;
    },
    /* 点击通过按钮 */
    pass () {
      if (this.isStore) {
        let that = this;
        this.$confirm({
          title: '申诉审核通过后，被申诉门店将会关闭',
          centered: true,
          content: h => <div style="color:red;">
            <p>1、停用 发布团购、代金券 功能</p>
            <p>2、停用 发布活动 功能</p>
            <p>3、退款 待使用的 团购、代金券订单</p>
            <p>4、退款 进行中的活动订单</p>
            <p>5、合同到期后，不用再生成续签合同</p>
            <p>6、资金管理功能能正常使用</p>
            <p style="color:#999">你还要继续么？</p>
          </div>,
          onOk () {
            that.$emit('pass');
          }
        });
      } else {
        this.$confirm({
          title: '确定通过审核？',
          centered: true,
          onOk: () => {
            this.$emit('pass');
          }
        });
      }
    },
    /* 点击确定弹窗 */
    confirm () {
      this.modalForm.validateFields((err, values) => {
        if (err) { return false; }
        this.$emit('reject', values.checkRemark);
      });
    }
  }
};
</script>

<style scoped>
.bottom_banner{
  padding:16px 20px;
  text-align: right;
  position: fixed;
  bottom: 0;
  width: calc(100% - 248px);
  height: 60px;
  margin-left: -20px;
  background: white;
  z-index: 999;
}
</style>
